var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-for":"goals"}},[_c('b-form-input',{attrs:{"type":"number","id":"goals","min":"0","max":"10"},on:{"change":function($event){return _vm.$emit('change-score', _vm.goals)}},model:{value:(_vm.goals),callback:function ($$v) {_vm.goals=$$v},expression:"goals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }